<template>
  <v-container fluid>
    <v-row
      align="start"
      justify="center"
    >
      <v-col cols="8">
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>
              {{
                "Formulaire de renseignement"
              }}
            </v-toolbar-title>
            <v-spacer />
            <v-tooltip bottom />
          </v-toolbar>

          <v-card-text>
            <v-form>
              <v-row
                v-for="question in questions"
                :key="question.id"
              >
                <v-col cols="4">
                  <p class="font-weight-medium my-5 ml-5">
                    {{ question.title }}
                  </p>
                </v-col>
                <v-col>
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <!-- TEXT -->
                      <v-text-field
                        v-if="question.type === 0"
                        v-model="question.value"
                        :label="question.description"
                        type="text"
                        v-on="on"
                      />

                      <!-- NUMBER -->
                      <v-text-field
                        v-if="question.type === 1"
                        v-model="question.value"
                        :label="question.description"
                        type="number"
                        v-on="on"
                      />

                      <!-- DATE -->
                      <v-menu
                        v-if="question.type === 2"
                        ref="dateField"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template #activator="{ on }">
                          <v-text-field
                            v-model="question.value"
                            :label="question.description"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          ref="picker"
                          v-model="question.value"
                          :max="new Date().toISOString().substr(0, 10)"
                          min="1950-01-01"
                          @change="save"
                        />
                      </v-menu>

                      <!-- OUI/NON -->
                      <v-row v-if="question.type === 3">
                        <v-radio-group
                          v-model="question.value"
                          row
                          class="ml-3"
                        >
                          <v-radio
                            value="1"
                            label="Oui"
                          />
                          <v-radio
                            value="0"
                            label="Non"
                          />
                        </v-radio-group>
                      </v-row>

                      <!-- OUI/NON/POURQUOI -->
                      <v-row v-if="question.type === 4">
                        <v-radio-group
                          v-model="question.radio"
                          row
                          class="ml-3"
                        >
                          <v-radio
                            value="1"
                            label="Oui"
                          />
                          <v-radio
                            value="0"
                            label="Non"
                          />
                        </v-radio-group>
                        <v-textarea
                          v-if="question.type === 4 && question.radio === '1'"
                          v-model="question.value"
                          auto-grow
                          row="1"
                          clearable
                          :label="question.description"
                          type="text"
                          :placeholder="question.help"
                        />
                      </v-row>
                    </template>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              :disabled="questions.filter((q) => q.value).length === 0"
              @click="finish"
            >
              Valider
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      date: null,
      menu: false,
    };
  },
  computed: {
    questions() {
      return this.$store.state.question.questions;
    },
    clientId() {
      return atob(this.$route.params.clientId);
    },
  },
  watch: {
    menu(val) {
      if (val) {
        setTimeout(() => { this.$refs.picker[0].activePicker = 'YEAR'; });
      }
    },
  },
  beforeMount() {
    this.getQuestions();
  },
  methods: {
    async finish() {
      const result = this.questions.filter((q) => q.value).map((q) => ({
        q_id: q.id,
        c_id: this.clientId,
        value: q.value,
      }));

      if (result.length > 0) {
        await this.$store.dispatch('question/sendResult', result);
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }
    },
    getQuestions() {
      this.$store.dispatch(
        this.$route.name === 'Form'
          ? 'question/getForClient'
          : 'question/getForAdminClient',
        this.clientId,
      );
    },
    save(date) {
      this.$refs.dateField[0].save(date);
    },
  },
};
</script>

<style></style>
